import { useSelector } from "react-redux";
import { RootState } from "../store/redux/store";
import { useQuery } from "@tanstack/react-query";
import { getNewReleases, getStats, getTopRatedVideos } from "../utils/queries";
import { Link } from "react-router-dom";
import NewReleases from "../components/swiper/NewReleases";
import ClientSlider from "../components/ClientsSlider";
import { FaChalkboardTeacher } from "react-icons/fa";
import { BsClock, BsFillJournalBookmarkFill } from "react-icons/bs";
import Archive from "../components/Archive";
import Footer from "../components/Footer";
import LectureTapes from "../components/LectureTapes";
import Numbers from "../components/Numbers";
import Testimonials from "../components/Testimonials";
import NavbarTop from "../components/NavbarTop";
import NavbarIcons from "../components/NavbarIcons";
import NavbarUser from "../components/NavbarUser";
import NavbarMobile from "../components/NavbarMobile";
import TopRated from "../components/swiper/TopRated";
import ceo from "../assets/images/delect.png";

export const NEW_VIDEOS_KEY = ["new_videos"];
export const STATS_KEY = ["stats"];
export const TOP_RATED_VIDEOS_KEY = ["top_rated_videos"];

const Home = () => {
  const user = useSelector((state: RootState) => state.user.currentUser);

  const { data, isLoading, isError } = useQuery({
    queryKey: NEW_VIDEOS_KEY,
    queryFn: getNewReleases,
    refetchOnWindowFocus: false,
    retry: false,
  });

  const { data: statsData, isError: isStatsError } = useQuery({
    queryKey: STATS_KEY,
    queryFn: getStats,
    refetchOnWindowFocus: false,
    retry: false,
  });

  const {
    data: topRatedData,
    isLoading: isTopRatedLoading,
    isError: isTopRatedError,
  } = useQuery({
    queryKey: TOP_RATED_VIDEOS_KEY,
    queryFn: getTopRatedVideos,
    refetchOnWindowFocus: false,
    retry: false,
  });

  return (
    <div className="flq-navbar-icons-existence">
      <NavbarTop page="Home" />

      <div className="py-7 flq-background-color-100">
        <div className="container pt-navbar" style={{ textAlign: "center" }}>
          <h1 className="display-3 mb-0" style={{ fontSize: "50px" }}>
            Learn to Play the Piano like a Pro
          </h1>
          <p className="my-3">
            We have carefully curated a list of piano lessons to help you learn
            and grow as a pianist.
          </p>
          <div className="py-1">
            <div className="row gy-4 align-items-center">
              <div className="col-auto mx-auto" data-animejs>
                {user ? (
                  <Link to="/library" className="btn btn-icon-sm">
                    <span className="btn-name">Get Started</span>
                  </Link>
                ) : (
                  <Link to="/register" className="btn btn-icon-sm">
                    <span className="btn-name">Get Started</span>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <NewReleases isError={isError} data={data} isLoading={isLoading} />
      <ClientSlider />
      <div
        className="py-7"
        style={{
          backgroundImage:
            "linear-gradient(95.92deg,#bc2fb2 0%,#f55267 49.13%,#feae71 100%)",
        }}
      >
        <div
          className="container text-center my-6"
          data-sr="start-30-days"
          data-sr-interval={100}
          data-sr-duration={1000}
          data-sr-distance={10}
        >
          <h1 className="display-1 mb-4" data-sr-item="start-30-days">
            Available on Web,
            <br />
            iOS and Android.
          </h1>
          <div className="row justify-content-center g-3">
            <div className="col-12 col-sm-auto" data-sr-item="start-30-days">
              <a
                href="https://apps.apple.com/us/app/tlp-mobile/id6738012299"
                target="_blank"
                rel="noreferrer"
                className="btn btn-block btn-black btn-glass btn-icon-xl"
              >
                <svg
                  width={18}
                  height={18}
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.0728 5.4325C14.9798 5.5048 13.348 6.424 13.348 8.4689C13.348 10.834 15.4239 11.6706 15.4859 11.6912C15.4756 11.7428 15.1554 12.8376 14.3911 13.953C13.7095 14.9342 12.9968 15.9153 11.9124 15.9153C10.828 15.9153 10.5491 15.2853 9.29942 15.2853C8.08072 15.2853 7.64692 15.936 6.65542 15.936C5.66392 15.936 4.97192 15.0271 4.17672 13.9117C3.25752 12.6 2.51392 10.5654 2.51392 8.6341C2.51392 5.5357 4.52792 3.8935 6.51082 3.8935C7.56432 3.8935 8.44212 4.5855 9.10312 4.5855C9.73312 4.5855 10.7143 3.8522 11.9123 3.8522C12.3668 3.8523 13.9987 3.8937 15.0728 5.4325ZM11.3444 2.5407C11.8401 1.952 12.1913 1.1361 12.1913 0.3202C12.1913 0.2066 12.181 0.093 12.1603 0C11.3547 0.031 10.3942 0.537101 9.81582 1.2084C9.36142 1.7248 8.93792 2.5407 8.93792 3.367C8.93792 3.4909 8.95862 3.6149 8.96892 3.6562C9.02052 3.6665 9.10322 3.6769 9.18582 3.6769C9.90882 3.6768 10.8176 3.1914 11.3444 2.5407Z"
                    fill="currentColor"
                  />
                </svg>
                <span className="btn-name">
                  <span className="btn-name-subtitle">Download on the</span>App
                  Store
                </span>
              </a>
            </div>
            <div className="col-12 col-sm-auto" data-sr-item="start-30-days">
              <a
                href="https://play.google.com/store/apps/details?id=com.delect.tlpMobile"
                className="btn btn-block btn-black btn-glass btn-icon-xl"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  width={18}
                  height={18}
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.7271 6.75078L10.3389 9.00003L12.727 11.2492L14.8516 10.0691C15.7161 9.5889 15.7161 8.41106 14.8516 7.93087L12.7271 6.75078ZM12.0758 6.38901L9.82125 8.51243L3.11301 2.19429C3.5067 1.96008 4.02839 1.91908 4.48726 2.17396L12.0758 6.38901ZM2.62535 2.71016C2.54549 2.86887 2.5 3.0485 2.5 3.24308V14.7569C2.5 14.9515 2.5455 15.1311 2.62538 15.2899L9.30357 9.00003L2.62535 2.71016ZM3.11307 15.8058C3.50675 16.0399 4.02842 16.0809 4.48726 15.826L12.0757 11.611L9.82125 9.48761L3.11307 15.8058Z"
                    fill="currentColor"
                  />
                </svg>
                <span className="btn-name">
                  <span className="btn-name-subtitle">Get it on</span>Google
                  Play
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {!isTopRatedError && (
        <TopRated
          isError={isTopRatedError}
          data={topRatedData}
          isLoading={isTopRatedLoading}
        />
      )}

      <div className="py-7 flq-background-color-100">
        <div className="container">
          <div className="row align-items-center justify-content-center g-6">
            <div
              className="col-12 col-xl-7 order-xl-5"
              data-sr
              data-sr-delay={300}
              data-sr-distance={10}
              data-sr-origin="right"
              data-sr-duration={1500}
            >
              <div
                className="card flq-card-image flq-card-favorites mb-4"
                data-sr-item="actor-image"
                style={{
                  visibility: "visible",
                  opacity: 1,
                  transform:
                    "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)",
                  transition:
                    "opacity 1s cubic-bezier(0.5, 0, 0, 1) 0.1s, transform 1s cubic-bezier(0.5, 0, 0, 1) 0.1s",
                  maxHeight: "500px",
                }}
              >
                <a href="#/" className="card-image">
                  <span className="flq-image flq-responsive flq-responsive-1x1 flq-responsive-lg-3x4">
                    <img src={ceo} alt="D Elect" />
                  </span>
                </a>
              </div>
            </div>
            <div
              className="col-12 col-lg-9 col-xl flq-vertical-rhythm text-center text-xl-start"
              data-sr="contact-text"
              data-sr-interval={100}
              data-sr-distance={10}
              data-sr-duration={1000}
            >
              <h2 className="h1" data-sr-item="contact-text">
                Live Piano Lessons with D'Elect
              </h2>
              <p data-sr-item="contact-text">
                Join a friendly group of learners for relaxed, live piano
                classes on Zoom, taught by D'Elect and a team of professional
                teachers.
              </p>

              <a
                href="https://zoom.thinklikeapianist.com"
                className="btn mt-0"
                data-sr
                data-sr-delay={200}
                data-sr-distance={10}
                data-sr-duration={1000}
              >
                Book Now
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="content-wrap">
        <div
          className="py-7 overflow-hidden flq-background flq-background-color-100"
          data-sr="features"
          data-sr-interval={100}
          data-sr-duration={1000}
          data-sr-distance={10}
        >
          <div className="flq-background-shape">
            <div data-rellax data-rellax-speed={1} className="mt-auto">
              <svg
                className="flq-translate-y50 ms-n7"
                width={866}
                height={831}
                viewBox="0 0 866 831"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M323.654 829.93C224.153 816.108 227.515 661.483 166.991 581.373C117.182 515.444 16.5101 485.726 2.15912 404.394C-12.2526 322.718 48.441 248.437 96.2908 180.687C138.901 120.355 193.017 70.7174 259.952 39.3885C326.181 8.38988 399.582 -9.42614 471.263 5.18105C541.916 19.579 590.604 76.5775 649.113 118.693C724.145 172.702 839.74 196.401 861.604 286.155C883.301 375.219 810.521 461.538 749.243 529.731C697.595 587.206 611.836 589.844 548.676 634.395C465.428 693.116 424.619 843.956 323.654 829.93Z"
                  fill="#fff"
                  fillOpacity="0.02"
                />
              </svg>
            </div>
            <div data-rellax data-rellax-speed={-1} className="ms-auto">
              <svg
                className="flq-translate-yn50 mt-n7 ms-7"
                width={782}
                height={865}
                viewBox="0 0 782 865"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M755.116 831.212C680.566 911.828 543.954 812.208 434.284 816.447C344.028 819.936 254.487 891.671 172.561 853.73C90.2879 815.629 61.5615 714.78 30.6714 629.531C3.16372 553.617 -7.56424 474.065 6.13963 394.452C19.6991 315.678 49.5645 238.707 107.441 183.536C164.489 129.156 246.033 121.094 320.36 94.9246C415.677 61.3647 509.14 -27.5167 603.314 8.94621C696.764 45.1286 728.741 164.34 751.641 261.91C770.941 344.146 719.74 422.719 720.256 507.206C720.936 618.565 830.763 749.41 755.116 831.212Z"
                  fill="#fff"
                  fillOpacity="0.02"
                />
              </svg>
            </div>
          </div>
          <div className="container">
            <div className="row gy-5 gx-6">
              <div className="col-lg-4">
                <h2 className="h1" data-sr-item="features">
                  Play Like A Pro At Your Own Pace
                </h2>
              </div>
              <div className="col-lg-8">
                <div className="row g-6">
                  <div className="col-12 col-sm-6" data-sr-item="features">
                    <div className="card flq-card-feature">
                      <div className="card-body">
                        <div className="card-icon">
                          <BsFillJournalBookmarkFill
                            style={{ width: "27px", height: "27px" }}
                          />
                        </div>
                        <div className="card-title h5">Exciting Courses</div>
                        <p>
                          Elevate your piano playing skills with ease. Whether
                          you're a novice or an experienced pianist, our dynamic
                          lessons offer a path to musical mastery at your own
                          pace.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-6" data-sr-item="features">
                    <div className="card flq-card-feature">
                      <div className="card-body">
                        <div className="card-icon">
                          <BsClock style={{ width: "27px", height: "27px" }} />
                        </div>
                        <div className="card-title h5">Always Available</div>
                        <p>
                          Our lessons are always available, ensuring that your
                          learning fits seamlessly into your schedule. Enjoy the
                          flexibility to practice and enhance your skills at any
                          time.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-6" data-sr-item="features">
                    <div className="card flq-card-feature">
                      <div className="card-body">
                        <div className="card-icon">
                          <FaChalkboardTeacher
                            style={{ width: "27px", height: "27px" }}
                          />
                        </div>
                        <div className="card-title h5">
                          Experienced Instructor
                        </div>
                        <p>
                          Experienced pianist to guide you on your musical
                          journey, providing expert insights, personalized
                          feedback and a wealth of knowledge to help you achieve
                          your piano playing goals.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6" data-sr-item="features">
                    <div className="card flq-card-feature">
                      <div className="card-body">
                        <div className="card-icon">
                          <svg
                            width={30}
                            height={30}
                            viewBox="0 0 30 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15 27.5C15 27.5 25 22.5 25 15V6.25L15 2.5L5 6.25V15C5 22.5 15 27.5 15 27.5Z"
                              stroke="currentColor"
                              strokeWidth="2.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="card-title h5">Affordable Plans</div>
                        <p>
                          Our budget-friendly options make high-quality musical
                          education accessible to all, ensuring that your
                          musical aspirations can thrive within your means.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Testimonials />
        <Archive />
        {isStatsError ? (
          <Numbers users={4753} videos={207} />
        ) : (
          <Numbers
            users={statsData?.totalUsers}
            videos={statsData?.totalVideos}
          />
        )}
        <LectureTapes />
        <Footer />
      </div>

      <NavbarIcons />
      <NavbarMobile page="Home" />
      <NavbarUser page="Home" />
    </div>
  );
};

export default Home;
